import { render, staticRenderFns } from "./CommentListItem.vue?vue&type=template&id=649f8ba4&"
import script from "./CommentListItem.vue?vue&type=script&lang=js&"
export * from "./CommentListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports